import { ListAttributeTypesResponse } from '@cbinsights/userv2service/userv2service';
import { UseQueryResult, useQuery } from 'react-query';
import { ListTeamAttributeTypes } from '.';
import { listTeamAttributeTypes } from '../api/ListTeamAttributeTypes';

type Return = ListAttributeTypesResponse;

/** Backend configuration, so it is treated as effectively static for a session. */
const ONE_HOUR = 60 * 60 * 1000;

export const useListTeamAttributeTypesQuery = ({
  enabled = false,
}: {
  enabled: boolean;
}): UseQueryResult<Return, Error> =>
  useQuery<Return, Error, Return, [ListTeamAttributeTypes]>(
    ['ListTeamAttributeTypes'],
    () => listTeamAttributeTypes(),
    {
      enabled,
      notifyOnChangeProps: ['data', 'isFetching'],
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
      retry: false,
      staleTime: ONE_HOUR,
    }
  );
